<p-dialog [(visible)]="visible" [modal]="true" [dismissableMask]="true"
          (onHide)="onHide()" (onShow)="onShow()"
          [style]="{ width: '480px' }"
          [contentStyle]="{ 'overflow-y': 'auto', padding: '0' }"
          styleClass="cardapio-info-dialog"
          maskStyleClass="cardapio-info-mask"
          [header]="'cardapio_digital.sidebar.titulo' | translate"
          [closable]="true"
          [draggable]="false"
          [resizable]="false"
          [appendTo]="'body'"
          position="center">

  <div class="dialog-info-content" *ngIf="estabelecimento">

    <!-- Status badge -->
    <div class="status-badge" [class.aberto]="estabelecimento.aberto" [class.fechado]="!estabelecimento.aberto">
      <span class="status-dot"></span>
      <span>{{ estabelecimento.aberto ? ('cardapio_digital.aberto' | translate) : ('cardapio_digital.fechado' | translate) }}</span>
    </div>

    <!-- Nome da loja + Logo -->
    <div class="store-header">
      <div class="store-info">
        <h2 class="store-name">{{ estabelecimento.nome }}</h2>
        <!-- Redes sociais + Avaliacao (inline) -->
        <div class="social-rating-row">
          <div class="social-icons">
            <a *ngIf="estabelecimento.telefoneWhatsapp"
               [href]="getWhatsappLink()"
               target="_blank" rel="noopener noreferrer"
               class="social-icon social-icon--whatsapp"
               title="WhatsApp">
              <i class="pi pi-whatsapp"></i>
            </a>
            <a *ngIf="estabelecimento.perfilInstagram"
               [href]="getInstagramLink()"
               target="_blank" rel="noopener noreferrer"
               class="social-icon social-icon--instagram"
               title="Instagram">
              <i class="pi pi-instagram"></i>
            </a>
            <a *ngIf="estabelecimento.perfilFacebook"
               [href]="getFacebookLink()"
               target="_blank" rel="noopener noreferrer"
               class="social-icon social-icon--facebook"
               title="Facebook">
              <i class="pi pi-facebook"></i>
            </a>
          </div>
          <div *ngIf="estabelecimento.avaliacao != null" class="avaliacao-row">
            <i class="pi pi-star-fill avaliacao-star"></i>
            <span class="avaliacao-nota">{{ estabelecimento.avaliacao }}</span>
          </div>
        </div>
      </div>
      <div class="store-logo-wrapper">
        <img *ngIf="estabelecimento.logo"
             [src]="estabelecimento.logo"
             [alt]="estabelecimento.nome"
             class="store-logo-img">
        <div *ngIf="!estabelecimento.logo" class="store-logo-placeholder">
          <i class="pi pi-shop"></i>
        </div>
      </div>
    </div>

    <!-- Separador -->
    <hr class="section-divider">

    <!-- Endereco -->
    <div class="section" *ngIf="estabelecimento.endereco">
      <h3 class="section-title">{{ 'cardapio_digital.sidebar.endereco_titulo' | translate }}</h3>
      <div class="endereco-row">
        <i class="pi pi-map-marker endereco-icon"></i>
        <span class="endereco-text">{{ estabelecimento.endereco }}</span>
      </div>
    </div>

    <!-- Tipos de servico -->
    <div class="section">
      <h3 class="section-title">{{ 'cardapio_digital.sidebar.tipos_servico_titulo' | translate }}</h3>
      <div class="tipos-servico-list">
        <!-- Entrega/Delivery -->
        <div class="tipo-servico-card">
          <div class="tipo-servico-info">
            <div class="tipo-servico-icon">
              <i class="pi pi-car"></i>
            </div>
            <span>{{ 'cardapio_digital.sidebar.entrega' | translate }}</span>
          </div>
          <i class="pi pi-check tipo-servico-check"></i>
        </div>
        <!-- Tempo de entrega -->
        <div class="tempo-entrega" *ngIf="estabelecimento.tempoEntregaMinimo != null && estabelecimento.tempoEntregaMaximo != null">
          <i class="pi pi-clock"></i>
          <span>{{ 'cardapio_digital.sidebar.tempo_entrega' | translate }} {{ estabelecimento.tempoEntregaMinimo }} - {{ estabelecimento.tempoEntregaMaximo }} {{ 'cardapio_digital.minutos_abreviado' | translate }}</span>
        </div>
        <!-- Retirada -->
        <div class="tipo-servico-card">
          <div class="tipo-servico-info">
            <div class="tipo-servico-icon">
              <i class="pi pi-shopping-bag"></i>
            </div>
            <span>{{ 'cardapio_digital.sidebar.retirada' | translate }}</span>
          </div>
          <i class="pi pi-check tipo-servico-check"></i>
        </div>
      </div>
    </div>

    <!-- Separador -->
    <hr class="section-divider">

    <!-- Horarios de atendimento -->
    <div class="section" *ngIf="horarios.length > 0">
      <h3 class="section-title">{{ 'cardapio_digital.sidebar.horarios_titulo' | translate }}</h3>
      <div class="horarios-list">
        <div class="horario-item" *ngFor="let h of horarios" [class.horario-atual]="h.atual" [class.horario-fechado]="h.fechado">
          <span class="horario-dia">{{ h.dia }}</span>
          <div class="horario-valor">
            <i class="pi pi-clock horario-clock"></i>
            <span [class.fechado-text]="h.fechado">{{ h.horario }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Meus Pedidos -->
    <div class="section pedidos-section" *ngIf="temHistorico">
      <hr class="section-divider">
      <button class="pedidos-dialog-btn" (click)="onVerHistorico()">
        <i class="pi pi-clock"></i>
        <span>{{ 'cardapio_digital.historico.botao_meus_pedidos' | translate }}</span>
      </button>
    </div>

    <!-- Footer versao -->
    <div class="dialog-footer">
      <span class="versao-text">{{ 'cardapio_digital.sidebar.versao' | translate }}</span>
    </div>

  </div>
</p-dialog>
